import {
  STORE_TO_IMAGE_LIST,
  STORE_SHEET_DATAS,
  RESET_SHEET_DATAS,
} from "./actionTypes"

const INIT_STATE = {
  sheets: null,
  imageList: [],
  error: {},
}

const Sheet = (state = INIT_STATE, action) => {
  switch (action.type) {
    case STORE_TO_IMAGE_LIST:
      return {
        ...state,
        sheetList: action.payload,
      }
    case STORE_SHEET_DATAS:
      return { ...state, sheets: action.payload }
    case RESET_SHEET_DATAS:
      return { ...state, sheets: null }
    default:
      return state
  }
}

export default Sheet
